import type { Rule } from '../type/rule';
export const QaCheckErrorCode = ({
  missingFields: 'missing-fields',
  unimplemented: 'unimplemented',
  invalidRuleResponse: 'invalid-rule-response'
} as const);
export type QaCheckErrorCode = (typeof QaCheckErrorCode)[keyof typeof QaCheckErrorCode];
export class QaCheckError extends Error {
  code: QaCheckErrorCode;
  constructor(message: string, errorCode: QaCheckErrorCode) {
    super(message);
    this.code = errorCode;
  }
}

// This error calls contain details which is useful for rendering meaning full error messages
export class QaCheckFormattedError extends QaCheckError {
  description: string;
  name: string;
  constructor(qaCheckError: QaCheckError, rule?: Rule<unknown>) {
    super(qaCheckError.message, qaCheckError.code);
    this.description = rule?.description ?? '';
    this.name = rule?.name ?? '';
  }
}